import { createContext, useContext, useMemo } from "react";

// Create a Context to store action handlers
const ActionHandlerContext = createContext({
  rowActionHandler: {},
  reportActionHandler: {},
  interfaceActionHandler: {},
  interfaceFieldActionHandler: {},
  autoSearchActionHandler: {},
});

// Provider component to wrap around your component tree
export const ActionHandlerProvider = ({
  children,
  rowActionHandler = {},
  reportActionHandler = {},
  interfaceActionHandler = {},
  interfaceFieldActionHandler = {},
  autoSearchActionHandler = {},
}) => {
  return (
    <ActionHandlerContext.Provider
      value={useMemo(
        () => ({
          rowActionHandler,
          reportActionHandler,
          interfaceActionHandler,
          interfaceFieldActionHandler,
          autoSearchActionHandler,
        }),
        [
          rowActionHandler,
          reportActionHandler,
          interfaceActionHandler,
          interfaceFieldActionHandler,
          autoSearchActionHandler,
        ]
      )}
    >
      {children}
    </ActionHandlerContext.Provider>
  );
};

// Custom hook to use the ActionHandlerContext
export const useActionHandler = () => {
  const context = useContext(ActionHandlerContext);
  if (!context) {
    throw new Error(
      "useActionHandler must be used within an ActionHandlerProvider"
    );
  }
  return context;
};
